import React from 'react';

import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';

import { TagType } from '../types/interfaces';

import './css/CharacteristicValueComponent.css';

type FormField =
  | 'id'
  | 'key'
  | 'type'
  | 'businessProcessName'
  | 'taskStatuses'
  | `taskStatuses.${number}`
  | `taskStatuses.${number}.id`
  | `taskStatuses.${number}.actionName`
  | 'actionName'
  | 'priority';

interface ObjectTypeCharacteristicsProps {
  errors: any;
  index: number;
  characteristic: TagType;
  passedClassName?: string;
  onInputChange: (value: string, property: FormField) => void;
  onDelete: () => void;
}

export const CharacteristicValueComponent: React.FC<
  ObjectTypeCharacteristicsProps
> = ({ errors, characteristic, passedClassName, onInputChange, onDelete }) => {
  const handleDeleteAll = () => {
    onDelete();
  };

  return (
    <div
      className={
        passedClassName +
        ' object-type-characteristic flex flex-row justify-content-between w-full'
      }
    >
      <InputText
        placeholder="Ввод значения"
        className={
          (errors?.label?.message ? 'p-invalid' : '') +
          ' object-type-characteristic__input'
        }
        value={characteristic.label}
        onChange={(e) => onInputChange(e.target.value, 'actionName')}
      />

      <Button
        icon="pi pi-trash"
        onClick={handleDeleteAll}
        className="p-button-danger"
        style={{ height: '40px' }}
      />
    </div>
  );
};
